export default __webpack_public_path__ + "static/logo-34a42b9ded1d2e876a8cb9578b3c2cea.png";